import { useState } from "react";
import { ArrowRight } from "lucide-react";

export default function DeviceMockup({ image, mobileImage, alt, testId }) {
  const [offset, setOffset] = useState({ x: 0, y: 0 });

  const handleMove = (event) => {
    const bounds = event.currentTarget.getBoundingClientRect();
    setOffset({ x: ((event.clientX - bounds.left) / bounds.width - 0.5) * 8, y: ((event.clientY - bounds.top) / bounds.height - 0.5) * 8 });
  };

  return (
    <div data-testid={testId} className="device-composition" onPointerMove={handleMove} onPointerLeave={() => setOffset({ x: 0, y: 0 })} style={{ "--parallax-x": `${offset.x}px`, "--parallax-y": `${offset.y}px` }}>
      <div className="browser-device">
        <div className="browser-chrome"><span className="window-dots"><i /><i /><i /></span><span className="browser-address">tfunsites.com / preview</span><span className="browser-lock">●</span></div>
        <div className="browser-screen"><img src={image} alt={alt} /></div>
        <div className="browser-footer"><span>DESKTOP PREVIEW</span><span><i /> LIVE SITE</span></div>
      </div>
      <div className="phone-device">
        <div className="phone-notch" />
        <div className="phone-screen"><img src={mobileImage || image} alt="Mobile website preview" /></div>
        <div className="phone-footer"><span>BOOK A TRIAL</span><ArrowRight size={11} /></div>
      </div>
    </div>
  );
}
